
<template>
    <div>
        <mars-view><top-bar title="案例解答" bg-color="#fff" text-color="#000"></top-bar><mars-view v-if="list && list.length" class="module"><mars-view v-for="(item, i) in list" :key="'card' + i" class="module-card-wrapper" @click.native="tapFn(item)"><case-card :datas="item" :is-vip="isVip && vipType !== 7 ? '1' : ''"></case-card></mars-view><mars-view v-if="noMoreResult" class="no-more-consult">暂无更多数据</mars-view></mars-view><lawyer-popup :consult-box="consultBox" :is-vip="isVip && vipType !== 7 ? '1' : ''"></lawyer-popup></mars-view>
    </div>
</template>

<script>
/* globals getApp */
import TopBar from "../../components/common/topbar.vue";
import CaseCard from "../../components/common/caseCard.vue";
import lawyerPopup from "../../components/common/lawyerPopup.vue";
import { getData } from '../../static/utils/request.js';
import { act } from '../../static/utils/navigate.js';
import { reqPathTo } from '../../static/utils/env.js';
import { setPageInfoMenu } from '../../static/utils/setPageInfoMenu';
import log from '../../static/utils/ubcLog';
import { getConsultInfo } from '../../static/utils/consultEvents.js';
import { handleSearch } from '../../static/utils/search';
export default {
  components: {
    'case-card': CaseCard,
    'lawyer-popup': lawyerPopup,
    'top-bar': TopBar
  },
  data() {
    return {
      topBar: {
        title: '律师问答',
        color: '#000',
        bgColor: '#fff'
      },
      pn: 1,
      rn: 10,
      noMoreResult: false,
      list: [],
      consultBox: {},
      menu: [],
      getExpertmoduleUrl: '',
      cursor: 0,
      // 请求下一页 需要带的参数
      limit: 10,
      isEnableReachBottom: false,
      // 是否触发下拉加载 后端接口返回有cursor字段才会触发上拉加载 (有cursor字段代表是百家号的)
      queryParams: {},
      qcNo: '',
      isVip: false,
      vipType: null // 会员类型
    };
  },

  methods: {
    init(options) {
      this.queryParams = options;
      this.initArticleList();
    },
    tapFn(item) {
      const {
        case_id
      } = item;
      log.send({
        serverId: 17155,
        area: 'yd-lsal-click',
        action: 'click',
        case_id
      });
      act({
        target: `/pages/expertmodule/caseDetail?caseId=${case_id}&qc_no=${this.qcNo}&fr=casemodule&isVip=${this.isVip ? '1' : ''}`,
        type: 'url'
      });
    },
    getMoreList() {
      if (!this.noMoreResult) {
        this.updateArticleList();
      }
    },
    initArticleList() {
      const {
        qc_no = ''
      } = this.queryParams;
      this.qcNo = qc_no;
      getData({
        url: reqPathTo('caselist', {}, '', 'falv/lawyer'),
        loginNeeded: false,
        data: {
          qc_no,
          pn: this.pn,
          rn: this.rn
        }
      }).then(data => {
        if (data && data.list) {
          this.list = data.list;
          if (data.list.length < this.rn) {
            this.noMoreResult = true;
          }
          this.pn = this.pn + 1;
          return;
        }
        getApp().$api.showModal({
          title: '加载异常',
          content: '案例列表加载失败，请稍后再试'
        });
      });
      Promise.all([getConsultInfo(qc_no), getData({
        url: reqPathTo('info', {
          qc_no: this.qcNo
        }, '', 'falv/lawyer'),
        loginNeeded: false
      })]).then(([res1, res2]) => {
        if (res2) {
          this.consultBox = {
            head: res2.stat && res2.stat.service_num,
            img: res2.personal_avatar,
            name: res2.name,
            tail: '人已咨询'
          };
          const domainList = res2.domain_list.map(item => item + '案例');
          setPageInfoMenu({
            title: `${res2.name}律师经典案例 - 法律咨询 - 百度律临`,
            keywords: `${res2.name}、律师案例、${domainList.join('、')}`,
            description: `百度律临为您提供${res2.name}律师经典成功案例汇总。律临同步提供包括婚姻家庭,劳动工伤,刑事辩护,交通事故,合同法,拆迁安置,知识产权,债务债权等多个法律分类的律师案例。找成功案例，就上百度律临！`
          });
          this.isVip = res2.is_vip || false;
          this.vipType = +res2.vip_type;
        }
        this.consultBox.lawyerServiceNew = res1 && res1.consult_service || {};
      });
    },
    updateArticleList() {
      // 异步请求律师
      const {
        qc_no
      } = this.queryParams;
      return this.$api.request({
        url: reqPathTo('caselist', {}, '', 'falv/lawyer'),
        loginNeeded: false,
        data: {
          qc_no,
          pn: this.pn,
          rn: this.rn
        }
      }).then(data => {
        if (data && data.list) {
          this.list = data.list;
          if (data.list.length < this.rn) {
            this.noMoreResult = true;
          }
          this.pn = this.pn + 1;
        }
      });
    },
    onReachBottom() {
      if (this.noMoreResult) {
        return;
      }
      this.getMoreList();
    }
  },
  created() {
    (function (ctx) {
      this.init(ctx);
      const fr = ctx.ref || ctx.fr || handleSearch();
      log.addKey({
        fr,
        vip: ctx.isVip ? '1' : '',
        page: 'case-module'
      });
      log.send({
        serverId: 17155,
        area: 'all_show',
        action: 'show'
      });
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.module {
  padding: 0.08rem 0.08rem 0.58rem;
}
.module-card-wrapper {
  padding: 0.15rem 0.13rem 0.17rem;
  background: #fff;
  border-radius: 0.12rem;
  margin-bottom: 0.08rem;
}
.no-more-consult {
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #848691;
  text-align: center;
  margin: 0.2rem 0;
}

</style>
